import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { listResponse } from '../../utils/listResponse';
import { pageSchema } from '../models/page.schema';
import { pagesQuerySchema } from './list.schema';

export type PagesQuery = {
  id?: ID | ID[];
  annotation?: ID | ID[];
  number?: number | number[];
  ordering?: 'id' | '-id' | 'number' | '-number';
  pageSize?: number;
  page?: number;
};

export const list = (query: PagesQuery) => {
  return {
    endpoint: `/pages`,
    method: 'GET',
    responseSchema: listResponse(pageSchema),
    querySchema: pagesQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
    query: { ...query, includeTotal: true },
  } as const;
};
